import React from 'react'
import Button from 'Molecules/Button'

import styles from './HeaderDrawer.module.scss'

const CallNow = () => {
    return (
        <div className={styles.drawerNavFooter}>
            <div className={styles.drawerCallButton}>
                <Button
                    href={'tel:18553139176'}
                    brand={'secondary'}
                    intent={'positive'}
                    invert
                    fill
                    size={'large'}
                    event={{
                        category: 'Header',
                        action: 'Call Us',
                        label: ''
                    }}
                    text={'Call Now'}
                />
            </div>
        </div>
    )
}

export default CallNow
